module.exports = __webpack_public_path__ + "media/images/pagetop-1c832e268247ebcf13d879f3d147aef0.png";